import { useSelector } from 'react-redux';
import { entriesSelector } from "../../store/selectors/entities/entries";
import { subSheetsSelector } from "../../store/selectors/entities/sheets";

// sheet_type_id options
export const LABELS_ABOVE_SHEET_TYPE_ID = 11;
export const LABELS_LEFT_SHEET_TYPE_ID = 10;
export const LOOP_SHEET_TYPE_ID = 15;
export const ADVANCED_LOOP_SHEET_TYPE_ID = 13;
export const LOOP_SHEET_TYPE_IDS = [LOOP_SHEET_TYPE_ID, ADVANCED_LOOP_SHEET_TYPE_ID];
export const DEFAULT_SHEET_TYPE_ID = LABELS_ABOVE_SHEET_TYPE_ID;

// style options
export const LABELS_ABOVE_STYLE = 0;
export const TABLE_STYLE = 1;
export const TABLE_PRE_POPULATED_STYLE = 2;
export const TABLE_LOOP_SHEET_STYLES = [TABLE_STYLE, TABLE_PRE_POPULATED_STYLE];
export const NON_TABLE_LOOP_SHEET_STYLES = [LABELS_ABOVE_STYLE];
// builder row and column padding settings
export const MIN_TABLE_COLS = 4;
export const MIN_TABLE_ROWS = 5;
const getSheetEntries = id => {
  const allEntries = useSelector(entriesSelector);
  return allEntries.filter(({
    sheet_id
  }) => sheet_id === id);
};
export const getSubSheetScreens = ({
  subSheets,
  ...sheet
}) => {
  const sheets = useSelector(subSheetsSelector);
  return subSheets.map(subSheetId => {
    const subSheet = sheets.find(({
      id
    }) => subSheetId == id);
    const entries = getSheetEntries(subSheetId);
    return {
      sheet,
      subSheet,
      entries
    };
  });
};
export const isTable = sheet => TABLE_LOOP_SHEET_STYLES.includes(sheet.style) && sheet.sheet_type_id === LOOP_SHEET_TYPE_ID;
export const isAdvancedLoop = sheet => sheet.sheet_type_id === ADVANCED_LOOP_SHEET_TYPE_ID;
export const isLoop = sheet => sheet.sheet_type_id === LOOP_SHEET_TYPE_ID;
export const isAnyLoop = sheet => [isTable(sheet), isAdvancedLoop(sheet), isLoop(sheet)].some(Boolean);
export const isList = sheet => isAnyLoop(sheet) && !sheet.multi_section;